import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { OnyxIconButtonComponent } from '../../../../buttons/onyx-icon-button/onyx-icon-button.component';
import { OnyxIconComponent } from '../../../../icons/onyx-icon/onyx-icon.component';
import { CalendarRole, CalendarView } from '../../../enums';

@Component({
  selector: 'onyx-datepicker-calendar-headbar',
  imports: [
    OnyxIconComponent,
    DatePipe,
    TitleCasePipe,
    OnyxIconButtonComponent,
  ],
  templateUrl: './onyx-datepicker-calendar-headbar.component.html',
  styleUrl: './onyx-datepicker-calendar-headbar.component.scss',
})
export class OnyxDatepickerCalendarHeadbarComponent {
  public readonly view = model.required<CalendarView>();
  public readonly date = input.required<string>();
  public readonly allowOpenChange = input(true);
  public readonly calendarRole = input(CalendarRole.FROM);

  public readonly monthChange = output<-1 | 1>();

  protected readonly CalendarView = CalendarView;
  protected readonly CalendarRole = CalendarRole;

  protected changeView(view: CalendarView): void {
    if (!this.allowOpenChange()) return;

    this.view.update((currentView) =>
      currentView !== view ? view : CalendarView.CALENDAR,
    );
  }
}
